<template class="itemdestaque">
  <div class="product" v-if="product != null">
    <router-link
      :to="`/${encodeURIComponent(this.nome_product)}/${encodeURIComponent(
        product.codigoDeBarras
      )}`"
    >
      <div class="product-inner">
        <div id="image-prod">
          <div class="product-image-wrap">
            <img :src="product.url" class="image" />
          </div>
        </div>
        <div class="product-detail">
          <h2>{{ product.nome }}</h2>
          <!-- <h2 v-if="product.nome.length < 13">{{ product.nome }}</h2> -->
          <!-- <h2 v-else>{{product.nome.substring(0, 21)+"..."}}</h2> -->
          <p class="produto-size">Tamanho: {{ product.tamanho }}</p>
          <div>
            <p id="oldvalue">
              de R$
              {{ product.preco.preco_venda.toFixed(2).replace(".", ",") }} por
            </p>
            <p v-if="product.preco.preco_desconto">
              R$ {{ product.preco.preco_desconto.toFixed(2).replace(".", ",") }}
            </p>
            <p v-else>R$ {{ a_vista_valor.toFixed(2).replace(".", ",") }}</p>
            <p id="oldvalue" v-if="product.qntParcelas != 1">
              ou R$ {{ product.preco.preco_venda.toFixed(2).replace(".", ",") }}
            </p>
            <p id="oldvalue" v-if="product.qntParcelas != 1">
              em {{ product.qntParcelas }}x de R$
              {{ valor_parcelas.toFixed(2).replace(".", ",") }}
            </p>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ItemDestaque",
  props: ["product"],
  data() {
    return {
      nome_product: "",
      a_vista_valor: 0,
      valor_parcelas: 0,
    };
  },
  beforeMount() {
    if (this.product) {
      if (!this.product.nome) {
        this.product = null;
      }

      //this.nome_product = this.product.nome.replace(" ", "-");
      this.nome_product = encodeURIComponent(this.product.nome);

      let preco = this.product.preco.preco_venda;
      preco = preco - (preco * 10) / 100;
      this.a_vista_valor = preco;

      this.valor_parcelas =
        this.product.preco.preco_venda / this.product.qntParcelas;
    }
  },
  methods: {},
};
</script>

<style>
a {
  text-decoration: none;
  color: #000000;
}

.itemdestaque .product .product-inner .product-detail h2 {
  text-transform: uppercase;
}

.itemdestaque  .product {
  margin: 10px;
  width: 210px;
}

.itemdestaque .product-inner {
  padding: 20px;
}

.itemdestaque #image-prod {
  display: block;
  align-self: center;
}

.itemdestaque .product-image-wrap {
  width: 160px;
}

.itemdestaque .product-image-wrap .image {
  height: 300px;
  width: 160px;
  object-fit: contain;
}

.itemdestaque .product-detail {
  padding: 25px;
  margin: 0px -25px -25px;
}

.itemdestaque .product-detail h2 {
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  line-height: 19px;
}

.itemdestaque .product-detail p {
  font-size: 21.6px;
  line-height: 1.5fr;
  text-align: left;
  font-weight: 700;
  color: #676767;
}

.itemdestaque #oldvalue {
  color: #8c8c8c;
  font-size: 0.95em;
  font-weight: normal;
}

.itemdestaque .product .product-inner .product-detail .produto-size {
  font-size: 14px;
  font-weight: lighter;
}

@media screen and (max-width: 800px) {
  .product {
    width: 100%;
    border-bottom: 1px solid #e4e4e4;
  }

  /* .product-image-wrap {
    width: 120px;
    height: 120px;
  }

  .product-image-wrap .image {
    height: 120px;
    width: 120px;
    object-fit: contain;
  } */

  .product-inner {
    display: inline-flex;
    background-color: #ffffff;
    height: 220px;
    width: 100%;
  }
}
</style>
